import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../App";

let cachedPerms = null;
let fetchPromise = null;

export const usePermissions = () => {
  const [perms, setPerms] = useState(cachedPerms);

  useEffect(() => {
    if (cachedPerms) { setPerms(cachedPerms); return; }
    if (!fetchPromise) {
      fetchPromise = axios.get(`${API}/role-matrix/my-permissions`)
        .then(res => { cachedPerms = res.data.permissions; return cachedPerms; })
        .catch(() => null);
    }
    fetchPromise.then(p => { if (p) setPerms(p); });
  }, []);

  const canEdit = (key) => {
    if (!perms) return true; // loading fallback
    return perms[key] === true;
  };

  const canViewAllLeads = perms?.view_all_leads === true;

  return { perms, canEdit, canViewAllLeads };
};
